import React from 'react'
import {plural} from '../functions'

const IncrementComp = ({name, value, max, min, title, subtitle, onClick}) => {
  const val = (value !== undefined)?value: min
  const minButton = (val !== min)?<div className="increment-icon" onClick={() => onClick({[name]: val - 1})}><i className="fa fa-minus" aria-hidden="true"></i></div>: ''
  const isMax = (val >= max)? {max: ''}: {}

  let plusClick = undefined
  if (val !== max) plusClick = () => onClick({[name]: (val + 1)})

  const mTitle = plural(value, title)

  return (
    <div className='increment-comp' {...isMax}>

        <div className='col-xs-9 col-md-9 col-lg-8 no-padding'>
          <p className='title'>{val} {mTitle}</p>
          <p className='subtitle'>{subtitle}</p>
        </div>

        <div className='col-xs-3 col-md-3 col-lg-4 no-padding'>
          <div className='col-xs-6 no-padding'>
            {minButton}
          </div>
          <div className='col-xs-6 no-padding'>
            <div className="increment-icon" {...isMax} onClick={plusClick}><i className="fa fa-plus" aria-hidden="true"></i></div>
          </div>
        </div>


    </div>
  )
}

export default IncrementComp



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/incrementComp.js